import React from "react";
import { Navbar, NavLeft, NavTitle, Link } from "framework7-react";

const AppNavbar = ({ title, backLink }) => {
  return (
    <Navbar>
      <NavLeft>
        {backLink && <Link back iconF7="arrow_left" />}
        <Link panelOpen="left" iconF7="bars" />
      </NavLeft>
      <NavTitle>{title}</NavTitle>
    </Navbar>
  );
};

export default AppNavbar;
